import BaseEnum from './BaseEnum';

export default class SortDirectionType extends BaseEnum{
    static ASC = 'ASC';
    static DESC = 'DESC';
    static NAME = 'NAME';
    static PRICE = 'PRICE';
    static CREATION_DATE = 'CREATION_DATE';
}
